/* eslint-disable no-restricted-globals */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  useState, useEffect, useMemo, FC,
  useCallback,
} from 'react';
import {
  Grid, Box, Container, Button, Typography,
} from '@mui/material';
import axios, { API } from 'lib/config/axios';
import PATHS from 'lib/navigation/paths';
import { useDispatch } from 'react-redux';
import { useSelector } from 'redux/app/store';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import {
  placeSlugTypes,
  FE_GEO_URL,
  PLACE_TYPES,
} from 'views/rebranded-module/GeoViewV2/utils/constants';
import { SLUGS_TYPES, GA_EVENT_CATEGORY } from 'lib/utils/CONSTANTS';
import {
  setSupressNavigationLoader,
  setLoading,
  setSnackbar,
} from 'redux/features/ui-slice';
import { hotjar } from 'react-hotjar';
import getConfig from 'next/config';
import Head from 'next/head';
import generateMetaData from 'lib/utils/generateMetaData';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import useCookies from 'views/common/hooks/useCookies';
import { getDayjsDate } from 'views/GeoView/utils/dateHandlers';
import {
  setHrefLangData,
  setGoogleAnalytics,
} from 'redux/features/globalData-slice';
import StyledBox from 'views/rebranded-module/GeoViewV2/GeoViewV2.styles';
import {
  Pagination,
  EagleSharePromoV2,
  EagleSharePromoSkeletonV2,
  Typography700,
  NoAvailableData,
} from 'views/rebranded-module/common/components';
import { LazyLoad } from 'views/common/components';
import generateGeoHrefLangs from 'views/GeoView/utils/generateGeoHrefLangs';
import { convertLatLngToDistanceInMiles } from 'lib/utils/convertLatLngToDistance';
import { notifyAirbrake } from 'lib/config/airbrake';
import { BE } from 'lib/navigation/apps';
import useGetLayout from 'views/common/hooks/useGetLayout';
import { PAGES_GA_IDENTIFIERS } from 'views/common/utils/constants';
import useLayoutHeights from 'views/rebranded-module/common/hooks/UseLayoutHeight';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';
import {
  PageTitleSection,
  BikeCardsSection,
  BikeCardsSectionSkeleton,
  MapSection,
  MapSectionSkeleton,
  NearbyRentalsWrapper,
  LinksGroupSectionSkeleton,
  OwnershipDisclaimerSection,
  OwnershipDisclaimerSectionSkeleton,
  MapAndFilter,
} from 'views/rebranded-module/GeoViewV2/components';
import { RiArrowLeftSLine } from 'react-icons/ri';
import { setFilters, clearFilters } from 'redux/features/geo-filters-slice';

const {
  publicRuntimeConfig: { envVars },
} = getConfig();

let controller: any;
// Extend the Window interface to include dataLayer

const GeoViewV2: FC<any> = (props) => {
  const {
    serverData, slugData, detectSlugLoading, isNoResultsPage,
  } = props;
  const cmsData = useContent();
  const { LAYOUT_HEIGHT } = useLayoutHeights();

  const appNavigator = useAppNavigator();
  const dispatch = useDispatch();
  const handleErrorResponse = useErrorsHandler();
  const [, setCookie, removeCookie] = useCookies();
  const { isCrawler, hreflangData, googleAnalytics } = useSelector(
    (state) => state.globalData,
  );
  const { getPageData } = useGetLayout();
  const [rentalData, setRentalData] = useState(serverData);
  const [isShownSideMap, setIsShownSideMap] = useState(!isCrawler);
  const [renderSkeleton, setRenderSkeleton] = useState(!serverData);
  const [skipMapSkeleton, setSkipMapSkeleton] = useState(false);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [widgetData, setWidgetData] = useState({ open: false });
  const [hoveredBike, setHoveredBikeId] = useState();
  // "Search this area" feature :
  // Stores the latest map bounds (lat, lng, radius) after a user pan/zoom.
  // When non-null, the "Search this area" button is visible on the map.
  // Cleared when the user clicks the button or when new results finish loading.
  const [unsearchedMapBounds, setUnsearchedMapBounds] = useState(null);
  // Tracks whether a "Search this area" API request is currently in-flight.
  // When true: map dragging is disabled, pins are non-clickable, and a
  // semi-transparent loading overlay is shown over the map.
  const [isMapLoading, setIsMapLoading] = useState(false);
  // this state is to determine that navigation is the special case where vehicle make
  // is equivilant to the url
  const [allowLocalizedNavigation, setAllowLocalizedNavigation] = useState(false);

  const handleMapLoadingFlag = useCallback((flag) => {
    setIsMapLoading(flag);
  }, [setIsMapLoading]);
  const isInternationalSameLocal = typeof window !== 'undefined'
    && window.location.pathname
      === `/${appNavigator.locale}/${appNavigator.locale}`;
  const isNearbyPlace = useMemo(() => {
    if (
      [
        PLACE_TYPES.AIRPORT,
        PLACE_TYPES.GEOGRAPHY,
        PLACE_TYPES.zipcode,
      ].includes(rentalData?.selected_filters.pickup_place?.placeable.type)
    ) {
      return true;
    }
    // current location
    return (
      rentalData?.selected_filters.pickup_place?.id === null
      && !rentalData?.selected_filters.pickup_place?.radius
    );
  }, [rentalData]);

  const getInOrNear = () => (isNearbyPlace ? 'near' : 'in');

  const getQuery = () => {
    const queries = {};
    if (typeof window === 'undefined') return {};
    window.location.search
      .slice(1)
      .split('&')
      .forEach((queryItem) => {
        const [key, value] = queryItem.split('=');
        queries[key] = value;
      });
    return queries;
  };

  const [queryData, setQueryData] = useState(getQuery());
  const handleBikeCardClick = (bike) => {
    if (bike.host?.type !== 'location') {
      // not an eaglerider bike
      return;
    }
    setWidgetData({
      open: true,
      data: {
        pickup_location_id: bike.host?.id,
        dropoff_location_id:
          rentalData?.selected_filters?.dropoff_location?.id || bike.host?.id,
        vehicle_model_id: bike.id,
        pickup_date: getDayjsDate(rentalData?.selected_filters?.pickup_date),
        dropoff_date: getDayjsDate(rentalData?.selected_filters?.dropoff_date),
        reservation_type_id: 1,
      },
      bikeData: {
        name: `${bike.vehicle_make.name} ${bike.vehicle_model.name}`,
        image: bike.image_url,
      },
    });
  };

  const handleMainWidgetDialogClose = () => {
    setWidgetData({ open: false });
  };
  const pagingData = useMemo(
    () => ({
      active_page: rentalData?.pagination?.current_page,
      pages_count: rentalData?.pagination?.pages_count,
    }),
    [rentalData],
  );

  const currentFilterParams = useMemo(() => {
    const sf = rentalData?.selected_filters;
    if (!sf) return {};
    return Object.fromEntries(
      [
        ['vehicle_make_id', sf.vehicle_make?.id],
        ['vehicle_type_id', sf.vehicle_type?.id],
        ['vehicle_model_id', sf.vehicle_model?.id],
        ['pickup_date', sf.pickup_date],
        ['dropoff_date', sf.dropoff_date],
        ['dropoff_location_id', sf.dropoff_location?.id],
      ].filter(([, value]) => value != null),
    );
  }, [rentalData]);

  const handleClick = () => {
    setIsShownSideMap((prevData) => !prevData);
  };

  const initPageParams = () => {
    const { slugs } = slugData;
    const query = queryData;
    return {
      pickup_place_slug:
        slugs.find(({ slug_type }) => placeSlugTypes.includes(slug_type))
          ?.slug || null,
      lat: query.lat || appNavigator.query.lat,
      lng: query.lng || appNavigator.query.lng,
      radius: query.radius || appNavigator.query.radius,
      dropoff_location_id:
        query.dropoff_geography_id || appNavigator.query.dropoff_geography_id,
      vehicle_make_slug:
        slugs.find(({ slug_type }) => slug_type === SLUGS_TYPES.vehicle_make)
          ?.slug || null,
      vehicle_model_slug:
        slugs.find(({ slug_type }) => slug_type === SLUGS_TYPES.vehicle_model)
          ?.slug || null,
      vehicle_type_slug:
        slugs.find(({ slug_type }) => slug_type === SLUGS_TYPES.vehicle_type)
          ?.slug || null,
      pickup_date: query.pickup_date || appNavigator.query.pickup_date,
      dropoff_date: query.dropoff_date || appNavigator.query.dropoff_date,
      page: query.page || appNavigator.query.page,
    };
  };
  const preparePageTitleProps = () => {
    if (!rentalData?.selected_filters) return {};
    const {
      vehicle_make, vehicle_model, vehicle_type, pickup_place,
    } = rentalData.selected_filters;
    let title = null;
    if (!vehicle_make && !vehicle_model && !vehicle_type) {
      if (!pickup_place) {
        title = cmsData.GeoPage.allERRentalsLabel;
      } else {
        const allERRentalsLocationLabel = getInOrNear() === 'in'
          ? cmsData.GeoPage.allERRentalsInLabelLocation
          : cmsData.GeoPage.allERNearRentalsNearLocationLabel;
        title = interpolateString(allERRentalsLocationLabel, {
          location: pickup_place.name,
        });
      }
    } else if (!pickup_place) {
      title = interpolateString(cmsData.GeoPage.rentalTypeslabel, {
        vehicle_make: vehicle_make ? vehicle_make.name : '',
        vehicle_model: vehicle_model ? vehicle_model.name : '',
        vehicle_type: vehicle_type ? vehicle_type.name : '',
      });
    } else {
      const allERRentalsTypesLocationLabel = getInOrNear() === 'in'
        ? cmsData.GeoPage.rentalTypesInLocationlabel
        : cmsData.GeoPage.rentalTypesNearLocationlabel;

      title = interpolateString(allERRentalsTypesLocationLabel, {
        vehicle_make: vehicle_make ? vehicle_make.name : '',
        vehicle_model: vehicle_model ? vehicle_model.name : '',
        vehicle_type: vehicle_type ? vehicle_type.name : '',
        location: pickup_place ? pickup_place.name : '',
      });
    }
    let subTitle = null;
    if (vehicle_model) {
      if (pickup_place) {
        const numberModelsAvailableForRentLabel = getInOrNear() === 'in'
          ? cmsData.GeoPage.numberModelsAvailableForRentInLocationLabel
          : cmsData.GeoPage.numberModelsAvailableForRentNearLocationLabel;

        subTitle = interpolateString(numberModelsAvailableForRentLabel, {
          count: rentalData?.total_count,
          vehicle_model: vehicle_model.name,
          location: pickup_place.name,
        });
      } else {
        subTitle = interpolateString(
          cmsData.GeoPage.numberModelsAvailableForRentLabel,
          {
            count: rentalData?.total_count,
            vehicle_model: vehicle_model.name,
          },
        );
      }
    } else if (pickup_place) {
      const numberMakeTypesAvailableForRentLabel = getInOrNear() === 'in'
        ? cmsData.GeoPage.numberMakesTypesAvailableForRentInLocationLabel
        : cmsData.GeoPage.numberMakesTypesAvailableForRentNearLocationLabel;

      subTitle = interpolateString(numberMakeTypesAvailableForRentLabel, {
        count: rentalData?.total_count,
        vehicle_make: vehicle_make ? vehicle_make.name : '',
        vehicle_type: vehicle_type ? vehicle_type.name : '',
        location: pickup_place.name,
      });
    } else {
      subTitle = interpolateString(
        cmsData.GeoPage.numberMakesTypesAvailableForRentLabel,
        {
          count: rentalData?.total_count,
          vehicle_make: vehicle_make ? vehicle_make.name : '',
          vehicle_type: vehicle_type ? vehicle_type.name : '',
        },
      );
    }

    const defaultTypeSlug = 'motorcycle-rental';
    let breadCrumbLinks = [
      {
        text: cmsData.GeoPage.eagleRiderLabel,
        path: PATHS.home(),
      },
      vehicle_type && {
        text: vehicle_type.slug ? vehicle_type.slug.split('-').join(' ') : '',
        path: PATHS.geoSlug([vehicle_type?.slug]),
      },
      pickup_place?.country && {
        text: pickup_place.country.name,
        path: PATHS.geoSlug([
          vehicle_type?.slug || defaultTypeSlug,
          pickup_place?.country?.slug,
        ]),
      },
      pickup_place?.region && {
        text: pickup_place.region.name,
        path: PATHS.geoSlug([
          vehicle_type?.slug || defaultTypeSlug,
          pickup_place.region.slug,
        ]),
      },
      pickup_place
        && pickup_place.placeable.type != 'country'
        && pickup_place.placeable.type != 'region' && {
        text: pickup_place.name,
        path: PATHS.geoSlug([
          vehicle_type?.slug || defaultTypeSlug,
          pickup_place.slug,
        ]),
      },
      vehicle_make && {
        text: vehicle_make.name,
        path: PATHS.geoSlug([vehicle_make?.slug, pickup_place?.slug]),
      },
      vehicle_model && {
        text: vehicle_model.name,
        path: '',
      },
    ].filter((item) => !!item);

    // Disable translation for breakcrumbs beacause it comes translated from the back end
    breadCrumbLinks = breadCrumbLinks.map((item) => ({
      ...item,
      translate: false,
    }));
    const lastBreadCrumbItem = breadCrumbLinks.pop();
    return {
      pageTitle: {
        title,
        subTitle,
      },
      breadcrumbsObject: {
        links: [...breadCrumbLinks, { ...lastBreadCrumbItem, path: '' }],
      },
    };
  };

  const prepareToNavigateInternally = (inside: any) => {
    dispatch(setSupressNavigationLoader(inside));
    setRenderSkeleton(inside);
  };
  const scrollToWidget = () => {
    window.scrollTo({
      top: LAYOUT_HEIGHT,
      behavior: 'smooth',
    });
  };
  const updateSlugs = (params) => {
    const {
      pickup_place_slug,
      vehicle_make_slug,
      vehicle_model_slug,
      vehicle_type_slug,
    } = params;

    const slugs = [];
    // instead of getting the locations state out in the view
    // i added it in the params object and if it's not present
    // this means we landed on it selected then we can get it from the selected filters
    const getSlugData = (index, slug) => {
      switch (index) {
        case 0:
          return {
            resource_id:
              rentalData.filters.vehicle_makes.find(
                (item) => item.slug === slug,
              )?.id || rentalData.selected_filters?.vehicle_make?.id,
            slug,
            slug_type: SLUGS_TYPES.vehicle_make,
          };
        case 1:
          return {
            resource_id:
              rentalData.filters.vehicle_types.find(
                (item) => item.slug === slug,
              )?.id || rentalData.selected_filters?.vehicle_type?.id,
            slug,
            slug_type: SLUGS_TYPES.vehicle_type,
          };
        case 2:
          return {
            resource_id:
              rentalData.filters.vehicle_models.find(
                (item) => item.slug === slug,
              )?.id || rentalData.selected_filters?.vehicle_model?.id,
            slug,
            slug_type: SLUGS_TYPES.vehicle_model,
          };
        case 3:
          // eslint-disable-next-line no-case-declarations
          const place = params.pickup_place;
          return {
            resource_id:
              place?.placeable?.id
              || rentalData.selected_filters.pickup_place?.placeable?.id,
            slug,
            slug_type:
              place?.placeable?.type
              || rentalData.selected_filters.pickup_place?.placeable.type,
          };
        default:
          return null;
      }
    };

    [
      vehicle_make_slug,
      vehicle_type_slug,
      vehicle_model_slug,
      pickup_place_slug,
    ].forEach((urlSlug, index) => {
      if (urlSlug) {
        slugs.push(getSlugData(index, urlSlug));
      }
    });
  };

  const getCurrentParams = () => {
    let pickupParams = {
      pickup_place_slug: rentalData?.selected_filters?.pickup_place?.slug,
    };
    if (rentalData?.selected_filters?.pickup_place?.id === null) {
      pickupParams = rentalData?.selected_filters?.pickup_place?.location;
    }
    return {
      ...pickupParams,
      radius: rentalData?.selected_filters?.pickup_place?.radius,
      dropoff_location_id: rentalData?.selected_filters?.dropoff_location?.id,
      vehicle_make_slug: rentalData?.selected_filters?.vehicle_make?.slug,
      vehicle_model_slug: rentalData?.selected_filters?.vehicle_model?.slug,
      vehicle_type_slug: rentalData?.selected_filters?.vehicle_type?.slug,
      pickup_date: rentalData?.selected_filters?.pickup_date,
      dropoff_date: rentalData?.selected_filters?.dropoff_date,
      page: rentalData?.pagination.current_page,
    };
  };
  const getNewParam = (param) => {
    const pickupParams = param.new_place_slug
      ? {
        pickup_place_slug: param.new_place_slug,
      }
      : {};
    const vehicleMakeSlug = param.new_vehicle_make_slug
      ? { vehicle_make_slug: param.new_vehicle_make_slug }
      : {};
    const vehicleModelSlug = param.new_vehicle_model_slug
      ? { vehicle_model_slug: param.new_vehicle_model_slug }
      : {};
    const vehicleTypeSlug = param.new_vehicle_type_slug
      ? { vehicle_type_slug: param.new_vehicle_type_slug }
      : {};
    return {
      ...pickupParams,
      ...vehicleMakeSlug,
      ...vehicleModelSlug,
      ...vehicleTypeSlug,
    };
  };
  const getRentalData = async (
    params,
    opts = { skeleton: true, spinner: false, scrollToTop: true },
    // eslint-disable-next-line consistent-return
  ) => {
    if (opts.scrollToTop) {
      if (rentalData) {
        scrollToWidget();
      }
    }
    setRenderSkeleton(opts.skeleton);
    dispatch(setLoading(opts.spinner));
    try {
      const [, res] = await getPageData(() => axios.get(API.rentals, { params, signal: controller?.signal }));
      if (res.data.rentals.length === 0) {
        if (rentalData) {
          setRentalData((prevData) => ({
            ...prevData,
            total_count: 0,
          }));
        }
      }
      setRentalData(res.data);
      const hrefLangs = generateGeoHrefLangs(res.data, appNavigator.locale);
      dispatch(setHrefLangData(hrefLangs));
      prepareToNavigateInternally(false);
      return res.data;
    } catch (err) {
      if (err.message === 'canceled') return null;
      switch (err.response?.status) {
        case 302:
          if (err.response.data.error_code === 'ERR002') {
            const newParams = {
              ...initPageParams(),
              ...getNewParam(err.response.data),
            };
            const {
              pickup_place_slug,
              dropoff_location_id,
              vehicle_make_slug,
              vehicle_model_slug,
              vehicle_type_slug,
              pickup_date,
              dropoff_date,
              page,
              lat,
              lng,
              radius,
            } = newParams;
            const queryParams = {};
            Object.entries({
              dropoff_geography_id: dropoff_location_id,
              pickup_date,
              dropoff_date,
              page,
              lat,
              lng,
              radius,
            }).forEach(([key, value]) => {
              if (value) queryParams[key] = value;
            });
            const geoPath = PATHS.geoSlug(
              [
                vehicle_make_slug,
                vehicle_type_slug,
                vehicle_model_slug,
                pickup_place_slug,
              ],
              queryParams,
            );
            appNavigator.push(geoPath);
          }
          break;

        default:
          handleErrorResponse(err);
          break;
      }
    } finally {
      dispatch(setLoading(false));
      // Clear the "Search this area" loading state once the API call resolves
      // (success or error). This re-enables map dragging, pin clicks, and
      // removes the loading overlay. Also clears any stale pending bounds
      // (e.g. if this fetch was triggered by a filter change, not by the button).
      setIsMapLoading(false);
      setUnsearchedMapBounds(null);
    }
  };
  const getParamsFromSlugsAndQuery = (slugsData, query) => {
    const { slugs } = slugsData;
    const {
      lat,
      lng,
      radius,
      pickup_date,
      dropoff_date,
      page,
      dropoff_geography_id,
    } = query;
    const paramsObj = {
      vehicle_make_id:
        slugs.find(({ slug_type }) => slug_type === SLUGS_TYPES.vehicle_make)
          ?.resource_id || null,
      vehicle_model_id:
        slugs.find(({ slug_type }) => slug_type === SLUGS_TYPES.vehicle_model)
          ?.resource_id || null,
      vehicle_type_id:
        slugs.find(({ slug_type }) => slug_type === SLUGS_TYPES.vehicle_type)
          ?.resource_id || null,
      lat,
      lng,
      radius,
      pickup_date,
      dropoff_date,
      page,
      dropoff_location_id: dropoff_geography_id,
    };
    const place = slugs.find(({ slug_type }) => placeSlugTypes.includes(slug_type));
    if (place) {
      paramsObj[`${place.slug_type}_id`] = place.resource_id;
    }
    return paramsObj;
  };

  const navigateToNewParams = (params, opts: { skipMapLocations?: boolean } = {}) => {
    const {
      pickup_place_slug,
      dropoff_location_id,
      vehicle_make_slug,
      vehicle_model_slug,
      vehicle_type_slug,
      pickup_date,
      dropoff_date,
      page,
      lat,
      lng,
      radius,
    } = params;
    const queryParams = {};
    Object.entries({
      dropoff_geography_id: dropoff_location_id,
      pickup_date,
      dropoff_date,
      page,
      lat,
      lng,
      radius,
    }).forEach(([key, value]) => {
      if (value) queryParams[key] = value;
    });
    setSkipMapSkeleton(!!opts.skipMapLocations);
    prepareToNavigateInternally(true);
    const geoPath = PATHS.geoSlug(
      [
        vehicle_make_slug,
        vehicle_type_slug,
        vehicle_model_slug,
        pickup_place_slug,
      ],
      opts.skipMapLocations ? { ...queryParams, skip_map_locations: '1' } : queryParams,
    );
    setQueryData(queryParams);
    const urlToGoTo = `${
      vehicle_type_slug === appNavigator.locale ? `/${vehicle_type_slug}` : ''
    }${geoPath.url}`;
    setCookie(FE_GEO_URL, urlToGoTo, {
      path: '/',
    });
    if (
      window.location.pathname.startsWith(urlToGoTo)
      && urlToGoTo === `/${appNavigator.locale}/${appNavigator.locale}`
    ) {
      history.pushState(
        undefined,
        undefined,
        appNavigator.appendQuery(
          appNavigator.getUrl(undefined, geoPath.url, false),
          geoPath.query,
        ),
      );

      const newSlugData = {
        slugs: slugData.slugs.filter((s) => {
          if (s.slug === 'no-results') {
            return false;
          }
          if (!pickup_place_slug) {
            return !placeSlugTypes.includes(s.slug_type);
          }
          return true;
        }),
      };
      const rentalsParams = getParamsFromSlugsAndQuery(
        newSlugData,
        geoPath.query,
      );
      getRentalData(rentalsParams);
      setAllowLocalizedNavigation(true);
      scrollToWidget();
      setAllowLocalizedNavigation(false);
      scrollToWidget();
    } else {
      if (controller) {
        controller.abort();
      }
      controller = new AbortController();
      updateSlugs(params);
      const displayAs = opts.skipMapLocations
        ? appNavigator.appendQuery(urlToGoTo, queryParams)
        : undefined;
      appNavigator.push(geoPath, displayAs, {
        translate: false,
        scroll: false,
      });
    }
  };
  const redirectToZeroResultsPage = () => {
    if (!isInternationalSameLocal) {
      const geoPath = PATHS.geoSlug('motorcycle-rental', 'no-results');
      appNavigator.push(geoPath, undefined, {
        scroll: false,
      });
    }
    dispatch(setLoading(false));
    setRenderSkeleton(false);
  };
  const isOnNoZeroResultsPage = () => isNoResultsPage
    && slugData?.slugs[1]?.slug === 'no-results'
    && appNavigator.asPath.endsWith('no-results');

  const handleFieldChange = (newParam) => {
    const params = { ...getCurrentParams(), ...newParam };
    navigateToNewParams(params);
  };
  const handlePaginationClick = (page) => {
    // force scroll first to fix ios issue
    window.scrollTo({ top: LAYOUT_HEIGHT, behavior: 'instant' });
    navigateToNewParams({ ...getCurrentParams(), page }, { skipMapLocations: true });
  };
  const handleFilterDialogOpen = () => {
    setOpenFilterDialog(true);
  };
  const handleFilterDialogClose = () => {
    setOpenFilterDialog(false);
  };

  const handleClearAllFilters = () => {
    handleFieldChange({
      vehicle_type_slug: 'motorcycle-rental',
      vehicle_make_slug: null,
      vehicle_model_slug: null,
      pickup_place_slug: null,
      dropoff_location_id: null,
      lat: null,
      lng: null,
      pickup_date: null,
      dropoff_date: null,
      page: null,
    });
  };
  const handleClearVehicleFilters = () => {
    handleFieldChange({
      vehicle_type_slug: 'motorcycle-rental',
      vehicle_make_slug: null,
      vehicle_model_slug: null,
    });
  };
  const handleNearByLinkClick = (path) => {
    setQueryData({});
    setCookie(
      FE_GEO_URL,
      `${
        path.url.startsWith(`/${appNavigator.locale}`)
          ? `/${appNavigator.locale}`
          : ''
      }${path.url}`,
      {
        path: '/',
      },
    );
  };

  const handleMapChange = (mapData) => {
    try {
      const { lat, lng, radius: radiusParams } = getCurrentParams();

      // eslint-disable-next-line no-undef
      const centerMapObj = new google.maps.LatLng(
        mapData.center.lat,
        mapData.center.lng,
      );
      const center = {
        lat: centerMapObj.lat(),
        lng: centerMapObj.lng(),
      };
      const radius = convertLatLngToDistanceInMiles(
        center.lat,
        mapData.bounds.nw.lng,
        center.lat,
        mapData.bounds.ne.lng,
      ) / 2;

      if (
        JSON.stringify({
          lat: center.lat,
          lng: center.lng,
          radius,
        })
        === JSON.stringify({
          lat: Number(lat),
          lng: Number(lng),
          radius: Number(radiusParams),
        })
      ) {
        return;
      }

      // Instead of immediately calling handleFieldChange (which triggers an API
      // request and URL navigation), we store the new bounds as "pending".
      // This shows the "Search this area" button on the map without fetching.
      // The actual fetch only happens when the user explicitly clicks that button
      // via handleSearchAreaBtnClick. This prevents the race condition where results
      // loading mid-interaction would reset the selected pin / vehicle model widget.
      setUnsearchedMapBounds({
        lat: center.lat,
        lng: center.lng,
        radius,
      });
    } catch (error) {
      notifyAirbrake(error);
      dispatch(
        setSnackbar({
          open: true,
          severity: 'error',
          message: cmsData.GeoPage.mapFailedLabel,
        }),
      );
    }
  };
  // Called when the user clicks the "Search this area" button on the map.
  // 1. Sets isMapLoading=true to disable map interactions and show the loading overlay.
  // 2. Triggers the actual data fetch via handleFieldChange -> navigateToNewParams -> getRentalData.
  // 3. Clears unsearchedMapBounds to hide the button immediately.
  // isMapLoading is reset to false in getRentalData's finally block once the API responds.
  const handleSearchAreaBtnClick = () => {
    if (!unsearchedMapBounds) return;
    setIsMapLoading(true);
    handleFieldChange({
      lat: unsearchedMapBounds.lat,
      lng: unsearchedMapBounds.lng,
      radius: unsearchedMapBounds.radius,
      pickup_place_slug: null,
      page: null,
    });
    setUnsearchedMapBounds(null);
  };
  const handleBikeCardHover = (bike) => {
    setHoveredBikeId(bike);
  };
  const placePositionLable = getInOrNear() === 'in'
    ? cmsData.GeoPage.inLabel
    : cmsData.GeoPage.nearLabel;

  const handleGetGeoDescriptionProps = (motorcycle, headingTitle = false) => ({
    make: rentalData.selected_filters.vehicle_make?.name || '',
    model: headingTitle
      ? ` ${rentalData?.selected_filters?.vehicle_model?.name || ''} ${
        rentalData?.selected_filters?.vehicle_type?.name || motorcycle
      }`
      : ` ${rentalData?.selected_filters?.vehicle_model?.name || ''} ${
        rentalData?.selected_filters?.vehicle_type?.name?.toLowerCase()
          || motorcycle
      }`,
    location: rentalData.selected_filters.pickup_place?.name
      ? ` ${placePositionLable} ${rentalData.selected_filters.pickup_place?.name}`
      : '',
    numberOfListings: rentalData.total_count,
  });

  const handlegetGeoTitle = () => {
    let title = '';
    if (!rentalData.selected_filters.pickup_place?.name) {
      title = interpolateString(cmsData.GeoPage.rentalTypeslabel, {
        vehicle_make: rentalData.selected_filters.vehicle_make?.name || '',
        vehicle_model: rentalData.selected_filters.vehicle_model?.name || '',
        vehicle_type: rentalData.selected_filters.vehicle_type?.name || '',
      });
    } else {
      const rentalTypesLocationLable = getInOrNear() === 'in'
        ? cmsData.GeoPage.rentalTypesInLocationlabel
        : cmsData.GeoPage.rentalTypesNearLocationlabel;
      title = interpolateString(rentalTypesLocationLable, {
        vehicle_make: rentalData.selected_filters.vehicle_make?.name || '',
        vehicle_model: rentalData.selected_filters.vehicle_model?.name || '',
        vehicle_type: rentalData.selected_filters.vehicle_type?.name || '',
        location: rentalData.selected_filters.pickup_place?.name || '',
      });
    }
    return title;
  };

  const prepareGeoTextProps = () => ({
    filteredVehicleMake: rentalData.selected_filters.vehicle_make?.name
      ? `{ ${rentalData.selected_filters.vehicle_make?.name} ${cmsData.GeoPage.motorcyclesLabel}
      }`
      : cmsData.GeoPage.motorcyclesLabel,
    filteredGeoCountry:
      rentalData.selected_filters.pickup_place?.country?.name
      || cmsData.GeoPage.usLabel,
    filteredVehicleMakeDisplayName:
      rentalData.selected_filters.vehicle_make?.name
      || cmsData.GeoPage.smallMotorcycleLabel,
    filteredGeoCity: rentalData.selected_filters.pickup_place?.name
      ? rentalData.selected_filters.pickup_place?.name.split(',')[0]
      : cmsData.GeoPage.cityLabel,
    filteredVehicleType:
      rentalData?.selected_filters?.vehicle_type?.name?.toLowerCase()
      || cmsData.GeoPage.smallMotorcycleLabel,
  });

  const handleNoResultsNavigate = () => {
    appNavigator.push({
      url: '/motorcycle-rental',
      app: BE,
    });
  };

  // this is to insta render the skeleton on detect slug call for better UI/UX
  useEffect(() => {
    if (!detectSlugLoading && !isNoResultsPage) {
      setRenderSkeleton(detectSlugLoading);
    }
  }, [detectSlugLoading]);
  useEffect(() => {
    const setFeUrlPopCookie = (e) => {
      let url = e.state?.as;
      if (!url) {
        url = e.target.location.pathname;
        // didnt use appNavigator.push cuz it will restart any way due to the locale collision
        window.location.href = url + e.target.location.search;
      }
      setCookie(FE_GEO_URL, url, {
        path: '/',
      });
    };

    if (
      isNoResultsPage
      && !isOnNoZeroResultsPage()
      && !allowLocalizedNavigation
    ) {
      return redirectToZeroResultsPage();
    }
    if (isNoResultsPage) return null;
    if (isNoResultsPage && !allowLocalizedNavigation) {
      return null;
    }

    dispatch(
      setGoogleAnalytics({
        ...googleAnalytics,
        newsLetterEventCategory: GA_EVENT_CATEGORY.geo,
      }),
    );

    window.addEventListener('popstate', setFeUrlPopCookie);
    window.dataLayer.push({
      event: 'BikeCardV3',
    });
    return () => {
      window.removeEventListener('popstate', setFeUrlPopCookie);
      removeCookie(FE_GEO_URL);
    };
  }, []);

  useEffect(() => {
    if (serverData) {
      setRentalData((prevData) => ({
        ...serverData,
        map_locations: serverData.map_locations ?? prevData?.map_locations,
      }));
      setSkipMapSkeleton(false);
      setRenderSkeleton(false);
      scrollToWidget();
      if (serverData?.page_configuration?.hotjar_enabled) {
        hotjar.initialize(envVars.HOTJAR_SITE_ID, 6);
      }
      window.gtag('event', 'landing_page_view', {
        page_identifier: PAGES_GA_IDENTIFIERS.GEO,
      });
    }
  }, [serverData]);
  useEffect(() => {
    window.gtag('event', 'landing_page_view', {
      page_identifier: PAGES_GA_IDENTIFIERS.GEO,
    });
  }, []);
  if (!rentalData && isNoResultsPage) {
    return (
      <StyledBox className="NODataWrapper" py={16}>
        <NoAvailableData
          title={cmsData.GeoPage.noRentalsLabelAvailable}
          description={cmsData.GeoPage.noRentalsLabelsAvailableDescription}
          handleClick={handleNoResultsNavigate}
          buttonText={cmsData.GeoPage.clearFiltersButtonLabel}
        />
      </StyledBox>
    );
  }

  const navbarFiltersData = useMemo(() => {
    if (!rentalData) return null;
    return {
      rentalData,
      handleFieldChange,
      openFilterDialog,
      handleClearAllFilters,
      handleClearVehicleFilters,
      handleFilterDialogClose,
    };
  }, [
    rentalData,
    handleFieldChange,
    openFilterDialog,
    handleClearAllFilters,
    handleClearVehicleFilters,
    handleFilterDialogClose,
  ]);
  useEffect(() => {
    if (navbarFiltersData) {
      dispatch(setFilters(navbarFiltersData));
    } else {
      dispatch(clearFilters());
    }
  }, [navbarFiltersData]);

  return (
    <StyledBox id="geoPage" className="" layoutHeight={LAYOUT_HEIGHT}>
      {rentalData?.seo_values && (
        <Head>
          {generateMetaData(rentalData.seo_values)}
          {/* To Fix zoomIn issue at ios */}
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, maximum-scale=1"
          />
          {hreflangData && !serverData && (
            <>
              <link rel="canonical" href={hreflangData?.canonical} />
              {hreflangData.urls?.map((local) => (
                <link
                  key={local.hreflang}
                  rel="alternate"
                  href={local.url}
                  hrefLang={local.hreflang}
                />
              ))}
            </>
          )}
        </Head>
      )}
      <Grid container>
        <Grid
          item
          xl={isShownSideMap ? 8 : 12}
          lg={isShownSideMap ? 7 : 12}
          md={12}
          xs={12}>
          <Container maxWidth="xxl" className="GVContainer">
            <Box className="GVPageTitleContainer">
              <PageTitleSection {...preparePageTitleProps()} />
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                className={` GVHideAndShowMapBtn showDESKTOP  ${
                  isShownSideMap ? 'GVShowMapBtn' : ''
                }`}
                onClick={handleClick}>
                <RiArrowLeftSLine className="GVIconBtn" />
              </Button>
            </Box>
            {!isNoResultsPage && (
              <>
                {renderSkeleton ? (
                  <BikeCardsSectionSkeleton
                    bikesCount={rentalData?.rentals?.length || 48}
                    isShownSideMap={isShownSideMap}
                  />
                ) : (
                  <BikeCardsSection
                    rentalData={rentalData}
                    widgetData={widgetData}
                    collapsed={isShownSideMap}
                    handleBikeCardClick={handleBikeCardClick}
                    handleMainWidgetDialogClose={handleMainWidgetDialogClose}
                    handleBikeCardHover={handleBikeCardHover}
                  />
                )}
              </>
            )}
            {pagingData?.pages_count > 1 && !isNoResultsPage && (
              <Box className="GVPaginationContiner" my={3}>
                <Pagination
                  data={pagingData}
                  url={pagingData.url}
                  link={pagingData.link}
                  handleChange={handlePaginationClick}
                />
              </Box>
            )}
            {(rentalData?.rentals?.length <= 0 || isNoResultsPage) && (
              <Box py={16}>
                <NoAvailableData
                  title={cmsData.GeoPage.noRentalsLabelAvailable}
                  description={
                    cmsData.GeoPage.noRentalsLabelsAvailableDescription
                  }
                  handleClick={handleClearAllFilters}
                  buttonText={cmsData.GeoPage.clearFiltersButtonLabel}
                />
              </Box>
            )}

            {(pagingData.active_page === pagingData.pages_count
              || rentalData?.total_count === 0) && (
              <Box className="GVESPromoContainer">
                <LazyLoad skeleton={<EagleSharePromoSkeletonV2 />} dataLoaded>
                  <Box className="GVPromoContiner">
                    <EagleSharePromoV2
                      path={
                        isNoResultsPage
                          ? PATHS.eagleshare(
                            '/motorcycle-rental',
                            appNavigator.locale,
                          )
                          : PATHS.eagleshare(
                            appNavigator.asPath.replace(/page=\d+/, 'page=1'),
                            appNavigator.locale,
                          )
                      }
                    />
                  </Box>
                </LazyLoad>
              </Box>
            )}
          </Container>
        </Grid>
        {isShownSideMap && (
          <Grid
            item
            xl={4}
            lg={5}
            md={12}
            xs={12}
            className="GVMapSide showDESKTOP">
            {!rentalData && renderSkeleton ? (
              <MapSectionSkeleton />
            ) : (
              /* Desktop sidebar map: unsearchedMapBounds/onSearchThisArea/isMapLoading
                  control the "Search this area" button visibility, click handler,
                  and loading overlay + disabled pins respectively. */
              <MapSection
                mapLocations={rentalData?.map_locations}
                selectedPlace={rentalData?.selected_filters.pickup_place}
                handleBikeCardClick={handleBikeCardClick}
                handleMapChange={handleMapChange}
                hoveredBike={hoveredBike}
                renderSkeleton={renderSkeleton && !skipMapSkeleton}
                currentFilterParams={currentFilterParams}
                unsearchedMapBounds={unsearchedMapBounds}
                onSearchThisArea={handleSearchAreaBtnClick}
                isMapLoading={isMapLoading}
                handleMapLoadingFlag={handleMapLoadingFlag}
              />
            )}
          </Grid>
        )}
      </Grid>
      <Box className="GVLinksGroupsContiner">
        <Container maxWidth="xxl">
          {renderSkeleton ? (
            <LinksGroupSectionSkeleton />
          ) : (
            <>
              <LazyLoad
                skeleton={<LinksGroupSectionSkeleton />}
                dataLoaded={
                  rentalData?.nearby_rentals && typeof window !== 'undefined'
                }>
                <NearbyRentalsWrapper
                  nearbyRentals={rentalData?.nearby_rentals}
                  handleNearByLinkClick={handleNearByLinkClick}
                />
              </LazyLoad>

              {rentalData && (
                <Box className="GVSEODescription">
                  <Typography700
                    variant="h6"
                    mb={3}
                    dangerouslySetInnerHTML={{
                      __html: handlegetGeoTitle(),
                    }}
                  />

                  <Typography
                    variant="body3"
                    color="text.secondary"
                    dangerouslySetInnerHTML={{
                      __html: interpolateString(
                        cmsData.GeoPage.lookingToRentLabel,
                        {
                          ...handleGetGeoDescriptionProps(
                            cmsData.GeoPage.smallMotorcycleLabel,
                          ),
                        },
                      ),
                    }}
                  />

                  <Typography
                    variant="body3"
                    color="text.secondary"
                    dangerouslySetInnerHTML={{
                      __html: interpolateString(
                        cmsData.GeoPage.whetherRentingLabel,
                        {
                          ...prepareGeoTextProps(),
                        },
                      ),
                    }}
                  />
                </Box>
              )}
            </>
          )}
        </Container>
      </Box>
      <Container maxWidth="xxl">
        {renderSkeleton ? (
          <OwnershipDisclaimerSectionSkeleton />
        ) : (
          <OwnershipDisclaimerSection />
        )}
      </Container>
      {/* Mobile map (bottom bar + fullscreen dialog): same "Search this area"
          props forwarded through MapAndFilter -> ShowMapDialogSection -> MapSection */}
      {!isCrawler && (
        <MapAndFilter
          isWigetOpen={widgetData.open}
          mapLocations={rentalData?.map_locations}
          selectedPlace={rentalData?.selected_filters.pickup_place}
          handleFilterDialogOpen={handleFilterDialogOpen}
          handleBikeCardClick={handleBikeCardClick}
          handleMapChange={handleMapChange}
          renderSkeleton={renderSkeleton}
          currentFilterParams={currentFilterParams}
          unsearchedMapBounds={unsearchedMapBounds}
          onSearchThisArea={handleSearchAreaBtnClick}
          isMapLoading={isMapLoading}
          handleMapLoadingFlag={handleMapLoadingFlag}
        />
      )}
    </StyledBox>
  );
};

export { GeoViewV2 };
